export const contactsFields = {
  ContactName: {
    fieldKey: "ContactName",
    element: "input",
    type: "text",
    title: "ContactName",
    placeholder: "contactname-placeholder",
    label: "contactname-label",
    containerClassName: "ContactName",
    // validation: {
    //   required: false,
    //   reg: /[^\n]+/,
    //   invalidMessage: "default-input-invalid-message",
    // },
  },
  Email: {
    fieldKey: "Email",
    element: "input",
    type: "email",
    title: "Email",
    label: "signin-email-label",
    placeholder: "signin-email-placeholder",
    containerClassName: "Email",
    validation: {
      required: true,
      invalidMessage: "invalid-email-text",
      reg: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    },
  },
  PhoneNumber: {
    fieldKey: "PhoneNumber",
    element: "input",
    type: "text",
    title: "PhoneNumber",
    label: "phonenumber-label",
    placeholder: "contacts-phonenumber-placeholder",
    containerClassName: "PhoneNumber",
    validation: {
      required: false,
      invalidMessage: "invalid-phone-text",
      reg: /^(?=.{9,18}$)[0-9#()+-]*$/,
    },
  },
};
